import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'totalpages',
    standalone: false
})
export class TotalPagesPipe implements PipeTransform {
    transform(totalLeads: number, pageSize: number): number {
        return Math.ceil(totalLeads / pageSize);
    }
}
